import { createBrowserRouter, Navigate } from "react-router-dom";
import ProcessingPaymentPage from "./common/ProcessingPaymentPage";

const processingPaymentRoutes = createBrowserRouter([
  {
    path: 'processing',
    element: undefined,
    children: [
      { path: 'payment', element: <ProcessingPaymentPage />, index: true }
    ]
  },
  {
    path: '*',
    element: <Navigate to='/processing/payment' />
  }
]);

export default processingPaymentRoutes;